import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks/reduxHooks';
import { selectIsAuth } from 'redux/selectors/selectors';

import { LOCAL_STORAGE } from 'shared/constants/local-storage-constants';

export const useProtectedRoute = (element: React.ReactElement) => {
  const token = localStorage.getItem(LOCAL_STORAGE.token);
  const refresh = localStorage.getItem(LOCAL_STORAGE.refreshToken);
  const isAuth = useAppSelector(selectIsAuth);

  return token || refresh || isAuth ? element : <Navigate to="/" replace />;
};
